<template>
  <span>
    <v-autocomplete
      class="select-all--user"
      v-model="valueUserTemp"
      :items="itemsDisplay"
      :label="label"
      :placeholder="placeholder"
      :multiple="multiple"
      :clearable="clearable"
      @change="onChangeUser(); changeUser(); keySearch = '';"
      :error-messages="errorMessages"
      :readonly="readonly"
      :disabled="disabled"
      chips
      :color="color"
      :item-text="itemText"
      :item-value="itemValue"
      :prepend-icon="prependIcon"
      :search-input.sync="keySearch"
      :hide-details="hideDetails"
    >
      <template #prepend-item>
        <common-select-all
          v-if="multiple"
          text="Tất cả Users Active"
          v-model="valueUserTemp"
          :items="items.filter(s => s.id).map(s => s.id)"
          @select-all="selectAll"
        />
      </template>
      <template #append-item>
        <common-select-all
          v-if="multiple && isManager() && showInactive"
          text="Tất cả Users Inactive"
          v-model="valueUserTemp"
          :items="items.filter(s => s.id && s.group == 'Inactive').map(s => s.id)"
          @select-all="selectAllInactive"
        />
      </template>
      <template v-if="multiple && !disabled" v-slot:selection="data">
        <v-chip
          class="bg-transparent"
          v-bind="data.attrs"
          :input-value="data.selected"
          close
          @click="data.select"
          @click:close="remove(data.item)"
        >{{ data.item.name || data.item.fullName }}</v-chip>
      </template>
      <template v-slot:item="data">
        <template v-if="typeof data.item !== 'object'">
          <v-list-item-content v-text="data.item" />
        </template>
        <template v-else>
          <v-list-item-action class="mr-3">
            <v-icon
              class="primary--text"
            >
              {{ checkUsers(data.item.id) }}
            </v-icon>
          </v-list-item-action>
          <v-list-item-avatar class="mr-3">
            <img v-if="data.item.avatar" :src="data.item.avatar" />
            <v-img v-else src="../../assets/default-avatar.jpg" />
          </v-list-item-avatar>
          <v-list-item-content class="pa-1 px-0">
            <v-list-item-title v-html="data.item.fullName || data.item.name " />
            <v-list-item-subtitle v-html="data.item.group" />
          </v-list-item-content>
        </template>
      </template>
    </v-autocomplete>
    <input style="display:none; height: 0px; width: 0px;" v-bind:value="valueUser" />
  </span>
</template>

<script>
export default {
  name: 'SelectUser',
  model: {
    prop: 'valueUser'
  },
  props: {
    changeUser: {
      type: Function,
      default: () => {},
    },
    itemText: {
      type: [String, Array, Function],
      default: 'text'
    },
    itemValue: {
      type: [String, Array, Function],
      default: 'value'
    },
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    multiple: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    dateRangeValue: {
      type: Array,
      default: () => []
    },
    valueUser: {
      type: [String, Number, Array],
      default: () => ''
    },
    errorMessages: {
      type: Array,
      default: () => []
    },
    readonly: {
      type: Boolean,
      default: false
    },
    items: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: ''
    },
    prependIcon: {
      type: String,
      default: ''
    },
    showInactive: {
      type: Boolean,
      default: false
    },
    hideDetails: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      valueUserTemp: [],
      itemsDisplay: [],
      keySearch: ''
    };
  },
  created() {
    this.itemsDisplay = _.cloneDeep(this.items)
    this.valueUserTemp = this.valueUser;
  },
  updated() {
    this.valueUserTemp = this.valueUser;
  },
  beforeDestroy () {
    this.$off('input')
  },
  watch: {
    items: {
      deep: true,
      handler(newVal) {
        this.itemsDisplay = _.cloneDeep(newVal)
      }
    }
  },
  methods: {
    onChangeUser() {
      this.$emit('input', this.valueUserTemp);
    },
    selectAll(value) {
      let active = this.items.filter(s => s.id).map(s => s.id)
      let temp = _.cloneDeep(this.valueUserTemp)
      if (value) {
        this.valueUserTemp = active;
      } else {
        this.valueUserTemp = [];
      }

      this.$emit('input', this.valueUserTemp);
    },
    remove(item) {
      const index = this.valueUserTemp.indexOf(item.id);
      if (index >= 0) this.valueUserTemp.splice(index, 1);
      this.$emit('input', this.valueUserTemp);
    },
    checkUsers(id) {
      if (this.valueUser == id || (_.isArray(this.valueUser) && this.valueUser.includes(id))) {
        return 'mdi-checkbox-marked'
      } else {
        return 'mdi-checkbox-blank-outline'
      }
    },
    selectAllInactive(value) {
      let inactive = this.items.filter(s => s.id && s.group == 'Inactive').map(s => s.id)
      let temp = []

      if (value) {
        inactive.forEach(id => {
          if (!this.valueUserTemp.includes(id)) {
            this.valueUserTemp.push(id)
          }
        })
      } else {
        this.valueUserTemp.forEach(id => {
          if (!inactive.includes(id)) {
            temp.push(id)
          }
        })
        this.valueUserTemp = _.cloneDeep(temp)
      }

      this.$emit('input', this.valueUserTemp);
    }
  }
};
</script>
<style scoped>
  /deep/.select-all--user .v-select__selections{
    height: 32px;
    overflow: hidden;
    min-height: 32px;
  }
</style>
